/**
 * Configuration for content cache utility
 * All magic numbers and constants are defined here
 */

export const CONTENT_CACHE_CONFIG = {
  // IndexedDB configuration
  database: {
    name: "content-cache",
    version: 3, // Incremented to remove old mappings store
    imagesStoreName: "images",
  },

  // Cache size limits
  maxCacheSizeMB: 300,
  maxCacheAgeDays: 30,

  // Default content type for images
  defaultContentType: "image/jpeg",

  // Index names for IndexedDB
  indexes: {
    timestamp: "timestamp",
  },
};

/**
 * Calculate maximum cache age in milliseconds
 * @returns {number} Maximum cache age in milliseconds
 */
export function getMaxCacheAgeMs() {
  const { maxCacheAgeDays } = CONTENT_CACHE_CONFIG;
  return maxCacheAgeDays * 24 * 60 * 60 * 1000;
}

/**
 * Calculate maximum cache size in bytes
 * @returns {number} Maximum cache size in bytes
 */
export function getMaxCacheSizeBytes() {
  const { maxCacheSizeMB } = CONTENT_CACHE_CONFIG;
  return maxCacheSizeMB * 1024 * 1024;
}
